import BaseModel from './BaseModel';

class Coordinator extends BaseModel {
    constructor(data = {}) {
      super(data);
      this.updateData(data);
    }

    updateData = (data) => {
      this.id = data.id;
      this.name = data.name || "";
      this.mobile_number = data.mobile_number || "";
      this.service_center_id = data.service_center_id || "";
      this.category ||= data.category || "3P";
      this.employee_id = data.employee_id || "";
    }

    toApiJson = () => {
      this.completeValidation();
      return {
        id: this.id,
        coordinator: {
          id: this.id,
          mobile_number: this.mobile_number,
          name: this.name,
          service_center_id: this.service_center_id,
          category: this.category,
          employee_id: this.employee_id,
        }
      }
    }

    validations = (field) => {
      return {
        name: () => {
          if (this[field].length === 0) {
            this.errors.name = "Please input Name.";
          } else {
            delete this.errors.name;
          }
        },
        mobile_number: () => {
          if(this[field].search(/^\d{10}$/) === -1) {
            this.errors.mobile_number = "Invalid mobile number format."
          } else {
            delete this.errors.mobile_number;
          }
        },
        employee_id: () => {
          if(this.category === '3P' && this[field].trim() === '') {
            this.errors.employee_id = "Please enter employee id."
          } else {
            delete this.errors.employee_id;
          }
        },
      }[field];
    }

    validate = (field) => {
      if (this.validations(field)) {
        this.validations(field)()
      }
    }
}

export default Coordinator;
